import { useState } from 'react';
import { Box, Container, Stack, Typography } from '@mui/material';
import { Icon } from '@iconify/react';
import Ayke from '../../../../../app/assets/images/landing/AYKA.png';
import yaantrac from '../../../../../app/assets/images/YaantracLogoNavbar.png';
import CustomButton from '../../../../components/buttons/CustomButton';
import sectionConstants from '../constants/SectionConstants';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../../../../../app/redux/hooks';
import './Navbar.scss';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const themes = useAppSelector(state => state.theme.theme);
  const dispatch = useAppDispatch();
  return (
    <Container className='navbar-container' maxWidth='lg'>
      <Stack
        direction='row'
        className='navbar'
        justifyContent='space-between'
        alignItems='center'
      >
        <Typography
          component='img'
          src={themes == 'ayka' ? Ayke : yaantrac}
          className='navbar-logo'
          onClick={() => navigate('/')}
        />
        <Icon
          icon='heroicons-solid:menu'
          onClick={() => setIsOpen(!isOpen)}
          className='menu-icon-navbar'
        />
        {isOpen && (
          <Stack
            direction='column'
            className='mobile-menu'
            alignItems='center'
            spacing={3}
            pr={5}
          >
            <Box sx={{ position: 'absolute', right: 0, top: 0 }}>
              <Icon
                icon='mingcute:close-fill'
                onClick={() => setIsOpen(!isOpen)}
                className='menu-icon-navbar'
                color='white'
              />
            </Box>

            <Link to='/home'>
              <Typography className='navbar-data'>{sectionConstants.Home}</Typography>
            </Link>

            <Link to='/about'>
              <Typography className='navbar-data'>{sectionConstants.AboutUs}</Typography>
            </Link>
            <Link to='/contact'>
              <Typography className='navbar-data'>
                {sectionConstants.ContactUs}
              </Typography>
            </Link>
            <CustomButton
              category='Login'
              className='navbar-login-button-mobile'
              onClick={() => navigate('/login')}
            />
          </Stack>
        )}
        <Stack
          direction='row'
          className='navbar-data-parent'
          alignItems='center'
          spacing={3}
          pr={5}
        >
          <Link to='/home'>
            <Typography
              className={
                pathname === '/home' || pathname === '/'
                  ? 'navbar-data-selected'
                  : 'navbar-data'
              }
            >
              {sectionConstants.Home}
            </Typography>
          </Link>
          <Link to='/about'>
            <Typography
              className={pathname === '/about' ? 'navbar-data-selected' : 'navbar-data'}
            >
              {sectionConstants.AboutUs}
            </Typography>
          </Link>
          <Link to='/contact'>
            <Typography
              className={pathname === '/contact' ? 'navbar-data-selected' : 'navbar-data'}
            >
              {sectionConstants.ContactUs}
            </Typography>
          </Link>
          <CustomButton
            category='Login'
            className='navbar-login-button nav-button'
            onClick={() => navigate('/login')}
          />
        </Stack>
      </Stack>
    </Container>
  );
};
export default Navbar;
